/**
 * Converts text to proper case (first letter of each word capitalized)
 * Allows all capitals input to be preserved
 * @param text - The text to convert
 * @returns The text in proper case, or all caps if input is all caps
 */
export const toProperCase = (text: string): string => {
  if (!text) return text;
  
  // Check if the input is all capitals or mostly all capitals
  // Filter out empty strings to handle trailing spaces
  const words = text.split(' ').filter(word => word.length > 0);
  const isAllCaps = words.length > 0 && words.every(word => word === word.toUpperCase());
  
  // If the entire input is all caps, preserve it
  if (isAllCaps) {
    return text;
  }
  
  return text
    .toLowerCase()
    .split(' ')
    .map(word => {
      // Handle special cases like "Mc", "Mac", "O'", etc.
      if (word.startsWith('mc') && word.length > 2) {
        return 'Mc' + word.charAt(2).toUpperCase() + word.slice(3);
      }
      if (word.startsWith('mac') && word.length > 3) {
        return 'Mac' + word.charAt(3).toUpperCase() + word.slice(4);
      }
      if (word.startsWith("o'") && word.length > 2) {
        return "O'" + word.charAt(2).toUpperCase() + word.slice(3);
      }
      if (word.startsWith("d'") && word.length > 2) {
        return "D'" + word.charAt(2).toUpperCase() + word.slice(3);
      }
      if (word.startsWith("l'") && word.length > 2) {
        return "L'" + word.charAt(2).toUpperCase() + word.slice(3);
      }
      
      // Handle hyphens
      if (word.includes('-')) {
        return word.split('-').map(part => part.charAt(0).toUpperCase() + part.slice(1)).join('-');
      }
      
      // Handle apostrophes - only capitalize the first letter of the word, not after apostrophe
      if (word.includes("'")) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }
      
      // Regular word
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
}; 